module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGdbd7e3163f6a1578b3d260df67636e79.dbd7e316.png";